<template>
    <div style="height:150px">

        <v-chart class="chart" :option="options" :autoresize="true" />
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue';
import 'echarts-liquidfill'
//import * as echarts from 'echarts';
export default defineComponent({
    name: 'ZhuangTai',
    components: {

    },
    props: { info: Object },
    setup(props) {

        const options = ref({

            series: [
                {
                    type: 'liquidFill', //水位图
                    radius: '80%', //显示比例
                    center: ['30%', '42%'], //中心点
                    amplitude: 20, //水波振幅
                    data: [0.5, 0.5, 0.5], // data个数代表波浪数
                    color: ['#2489ff'], //波浪颜色
                    backgroundStyle: {
                        borderWidth: 6, //外边框
                        borderColor: '#2489ff', //边框颜色
                        color: '#485C6D', //边框内部填充部分颜色
                    },
                    label: {
                        //标签设置
                        normal: {
                            position: ['50%', '30%'],
                            formatter: '', //显示文本,
                            textStyle: {
                                fontSize: '16px', //文本字号,
                                color: '#fff',
                            },
                        },
                    },
                    outline: {
                        show: false,//最外层边框显示控制
                    },
                },
            ],

        });



        watch(props, () => {
            let status = ''
            if (props.info.status == 'NORMAL') {
                status = '正常'
            } else {
                status = '告警'
            }

            options.value.series[0].label.normal.formatter = status
        }, {
            deep: true
        });


        onMounted(() => { //组件挂载时的生命周期执行的方法


        });

        return {

            options

        }
    }

})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
